// CSV referenced in theme settings
// CSV formatted so that each guide is separated by an empty line
// First row in the guide is the product name which is used for matching

import Papa from 'papaparse'

const { templateName, sizeGuidesUrl, pdpSizeGuide } = globalThis.PS
const { sessionStorage: ss } = globalThis

if (templateName === 'product' && sizeGuidesUrl.length && pdpSizeGuide.length) {
  loadSizeGuide()
}

async function loadSizeGuide() {
  let tableData = []
  let tables = {}
  let currentTable = null

  try {
    if (ss.getItem('psSizeGuides')) {
      tableData = JSON.parse(ss.getItem('psSizeGuides'))
    } else {
      const results = await new Promise((resolve, reject) => {
        Papa.parse(sizeGuidesUrl, {
          download: true,
          skipEmptyLines: false,
          complete: resolve,
          error: reject
        })
      })

      tableData = results.data
      ss.setItem('psSizeGuides', JSON.stringify(tableData))
    }

    tableData.forEach((row) => {
      // Check if row is empty (table break)
      if (row.length === 0 || Object.values(row).every((val) => val.trim() === '')) {
        currentTable = null // Reset for the next section
        return
      }

      if (!currentTable) {
        // First row after an empty line is the table name
        currentTable = row[0]
        tables[currentTable] = { headers: row.slice(1), rows: [] }
      } else {
        // Remaining rows are table data
        tables[currentTable].rows.push({ name: row[0], values: row.slice(1) })
      }
    })

    buildTable(tables, pdpSizeGuide)
  } catch (err) {
    console.error(err)
    console.log('%cPS: There was an error downloading the size guides CSV file.', 'color: pink;')
  }
}

// Append size guide table to DOM from parsed data
function buildTable(tables, targetTableName) {
  const $container = document.querySelector('.accordion__sizing')

  if (!tables[targetTableName] || !$container) {
    console.warn(`Table "${targetTableName}" not found or container unavailable.`)
    return
  }

  // Build unit toggles
  const $toggleWrapper = document.createElement('div')
  const $btnCm = document.createElement('button')
  const $btnInch = document.createElement('button')

  $toggleWrapper.classList.add('unit-toggle')
  $btnCm.id = 'btn-cm'
  $btnCm.textContent = 'CM'
  $btnCm.style.textDecoration = 'underline'
  $btnCm.addEventListener('click', () => toggleUnits('cm'))
  $btnInch.id = 'btn-inch'
  $btnInch.textContent = 'Inch'
  $btnInch.addEventListener('click', () => toggleUnits('inch'))
  $toggleWrapper.appendChild($btnCm)
  $toggleWrapper.appendChild($btnInch)
  $container.appendChild($toggleWrapper)

  // Build Table
  const tableData = tables[targetTableName]
  const $table = document.createElement('table')
  const $tbody = document.createElement('tbody')

  $table.classList.add('size-guide-table')

  const colCount = tableData.rows.length ? tableData.rows[0].values.filter((v) => v && v.trim() !== '').length : 0

  tableData.rows.forEach((row, rowIndex) => {
    const $tr = document.createElement('tr')
    let tds = row.values
      .slice(0, colCount)
      .map((v, colIndex) => `<td data-row='${rowIndex}' data-col='${colIndex}' data-original='${v}'>${v}</td>`)
    $tr.innerHTML = `<td>${row.name}</td>` + tds.join('')
    $tbody.appendChild($tr)
  })

  $table.appendChild($tbody)
  $container.appendChild($table)
}

function formatNumber(num) {
  return Number.isInteger(num) ? num.toString() : num.toFixed(1)
}

// Toggle between cm and inches
function toggleUnits(unit) {
  const conversionFactor = 2.54 // 1 inch = 2.54 cm
  const table = document.querySelector('.size-guide-table')
  if (!table) return

  const cells = table.querySelectorAll('tbody td[data-row][data-col]')
  cells.forEach((cell) => {
    const rowIndex = cell.dataset.row
    if (rowIndex === '0') return // Skip the first row (index 0)

    let originalValue = parseFloat(cell.getAttribute('data-original'))

    if (!isNaN(originalValue)) {
      let value = unit === 'inch' ? originalValue / conversionFactor : originalValue
      cell.textContent = formatNumber(value)
    }
  })

  document.getElementById('btn-cm').style.textDecoration = unit === 'cm' ? 'underline' : 'none'
  document.getElementById('btn-inch').style.textDecoration = unit === 'inch' ? 'underline' : 'none'
}

// Event Listeners for buttons
if (document.getElementById('btn-cm')) {
  document.getElementById('btn-cm').addEventListener('click', () => toggleUnits('cm'))
}

if (document.getElementById('btn-inch')) {
  document.getElementById('btn-inch').addEventListener('click', () => toggleUnits('inch'))
}
